export default __webpack_public_path__ + "assets/images/091055269c94e06199f8afdbd436e46e.png";